import DesignGuidelinesSummary from '../../_components/DesignGuidelinesSummary';
import { useAppSelector } from '../../../Common/_hooks/useAppSelector';
import useLabData from '../../_hooks/useLabData';
import GuidelinesPanel from './ImageLibraryGuidelinesPanel';

export default function ImageLibraryDesignGuidelines() {
	const activeProductId = useAppSelector(state => state.get('UIData').get('designLab').get('activeProductId'));
	const activeVariant = useAppSelector(state => state.get('UIData').get('designLab').get('activeVariant'));
	const productData = useAppSelector(state => (
		activeProductId !== null
			? state.get('appData').get('products').get(String(activeProductId))
			: undefined
	));
	const labData = useLabData();

	if (labData === undefined) {
		return null;
	}

	return <GuidelinesPanel spacing={1.25}>
		<DesignGuidelinesSummary
			labData={labData}
			selectedVariant={activeVariant}
			productName={productData?.get('name')}
		/>
	</GuidelinesPanel>
}
